import { createSlice } from '@reduxjs/toolkit';
import { setHours, setMinutes } from 'date-fns';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    icon: '',
    label: '',
    linkId: 0,
    position: 'Splash Screen',

    tillDate: setHours(setMinutes(new Date(), new Date().getMinutes()), new Date().getHours()),
    loopTimestamp: '',
    title: '',
    type: 1,

    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const timerSlice = createSlice({
  name: 'timer',
  initialState,
  reducers: {
    timerStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      const tillDateTimer = new Date(Date.parse(blockContent.tillDate));

      const currentTillDate = blockContent.tillDate
        ? setHours(setMinutes(tillDateTimer, tillDateTimer.getMinutes()), tillDateTimer.getHours() - tillDateTimer.getTimezoneOffset() / 60)
        : setHours(setMinutes(new Date(), new Date().getMinutes()), new Date().getHours());

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        message: blockContent.message ?? '',
        frequency: blockContent.frequency ?? 1,
        delay: blockContent.delay ?? 0,

        icon: blockContent.icon ?? '',
        label: blockContent.label ?? '',
        linkId: blockContent.linkId ?? 0,
        position: blockContent.position ?? 'Splash Screen',

        tillDate: currentTillDate ? currentTillDate : setHours(setMinutes(new Date(), new Date().getMinutes()), new Date().getHours()),
        loopTimestamp: blockContent.loopTimestamp ?? '',
        title: blockContent.title ?? '',
        type: blockContent.type ?? 1,

        // heading: {
        //   title: blockContent.heading.title ?? '',
        //   description: blockContent.heading.description ?? '',
        //   textAlign: blockContent.heading.textAlign ?? 'left',
        //   image: blockContent.heading.image ?? '',
        //   divider: blockContent.heading.divider ?? '',
        //   position: blockContent.heading.position ?? '',
        // },
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? 'feed',
      };
    },
    timerClear: () => initialState,

    timerUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    timerUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    timerUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    timerUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { timerStore, timerClear, timerUpdateIsLoading, timerUpdateIsActive, timerUpdateBlockContent, timerUpdateBlockDesign } = timerSlice.actions;

export const selectTimerIsLoading = (state) => state.timer.isLoading;
export const selectTimerIsActive = (state) => state.timer.isActive;

export const selectTimerId = (state) => state.timer.id;
export const selectTimerUID = (state) => state.timer.uid;
export const selectTimerSID = (state) => state.timer.sid;

export const selectTimerBlockContent = (state) => state.timer.blockContent;
export const selectTimerBlockDesign = (state) => state.timer.blockDesign;

export const selectTimerItemDesign = (state) => state.timer.itemDesign;
export const selectTimerContainerDesign = (state) => state.timer.containerDesign;

export default timerSlice.reducer;
